import { Pipe, PipeTransform } from "@angular/core";
import { Employee, EmployeeGroupe } from "../_interfaces/Employee";
import { TicketEditService } from "../_provider/ticket-edit.service";

@Pipe({
    name: "TicketEmployees"
})
export class TicketEmployees implements PipeTransform{

    constructor(
        private ticketEditSrv: TicketEditService
    ) {}

    /**
     * Gibt eine Liste von Mitarbeitern zurück anhand einer Liste an Idsa
     * @param {number[]} activeEmployees Liste der zugeordn
     * @param args 
     */
    transform(activeEmployees: number[], ...args: any[]):Employee[] {
        return this.ticketEditSrv.employees.filter(e => activeEmployees?.includes(e.id))
    }

}

@Pipe({
    name: "TicketGroups"
})
export class TicketGroups implements PipeTransform{
    
    constructor(
        private ticketEditSrv: TicketEditService
    ){

    }
    transform(activeGroups: number[], ...args: any[]): EmployeeGroupe[] {
        return this.ticketEditSrv.employeeGroupes.filter(e => activeGroups?.includes(e.id))
    }

}